function init() {

    const menuItemsWide = document.querySelectorAll('.wp-block-navigation-item__label');
    const menuItemsMobile = document.querySelectorAll('.wp-block-navigation-item__content');

    menuItemsWide.forEach((item, key) => {
        item.addEventListener('mouseover', ()=>{
            item.style.borderColor = 'rgba(0, 169, 225, 0)';
            if(key != menuItemsWide.length - 1){
                menuItemsWide[ key + 1 ].style.borderColor = 'rgba(0, 169, 225, 0)';
            }
        })
        item.addEventListener('mouseout', ()=>{
            item.style.borderColor = 'rgba(0, 169, 225, 0.5)';
            if(key != menuItemsWide.length - 1){
                menuItemsWide[ key + 1 ].style.borderColor = 'rgba(0, 169, 225, 0.5)';
            }
        })
    })

    menuItemsMobile.forEach((item, key) => {
        item.addEventListener('mouseover', ()=>{
            item.style.borderColor = 'rgba(0, 169, 225, 0)';
            if(key != 0){
                menuItemsMobile[ key - 1 ].style.borderColor = 'rgba(0, 169, 225, 0)';
            }
        })
        item.addEventListener('mouseout', ()=>{
            item.style.borderColor = 'rgba(0, 169, 225, 0.5)';
            if(key != 0){
                menuItemsMobile[ key - 1 ].style.borderColor = 'rgba(0, 169, 225, 0.5)';
            }
        })
    })
}

export { init as default };
